import React from "react"

const Title = ({ explorer, microcopy }) => (
  <header id="response-output">
    <h2>
      <a href="#response-output">
        {microcopy.text("explorer.titles.response")}
        {' '}
        (HTTP
        {explorer.statusCode}
        )
      </a>
    </h2>
  </header>
)

export default Title
